import useSWR, { type SWRConfiguration } from 'swr';

import { buildQueryKey } from '@common/utils/buildQueryKey';

import {
  getSuperlikesIncoming,
  type GetSuperlikesIncomingParams,
  type GetSuperlikesIncomingResponse,
} from '@services/SuperlikesService';

export type UseGetSuperlikesIncomingParams = {
  isEnabled: boolean;
  queryParams?: GetSuperlikesIncomingParams;
  swrOptions?: SWRConfiguration<GetSuperlikesIncomingResponse, unknown>;
};

export const getSuperlikesIncomingQueryKey = (
  queryParams?: GetSuperlikesIncomingParams,
) => buildQueryKey('get-superlikes-incoming', queryParams);

export const useGetSuperlikesIncoming = ({
  isEnabled,
  queryParams,
  swrOptions,
}: UseGetSuperlikesIncomingParams) => {
  const { data, ...swrResponse } = useSWR<GetSuperlikesIncomingResponse>(
    isEnabled ? getSuperlikesIncomingQueryKey(queryParams) : null,
    () => getSuperlikesIncoming(queryParams),
    swrOptions,
  );

  return {
    data,
    ...swrResponse,
  };
};
